export async function fetchApplicationList({ request }) {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_BASE_URL}/app/v1/get_user_application_list?request=${request}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: "",
    }
  );

  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    return Promise.reject(errorData?.detail || "fetch applications failed");
  }

  return res.json();
}
